import { useTranslation } from 'react-i18next';
import { selectOptionalUser } from 'features/auth/store/authSelectors';
import { useAppSelector } from 'features/store/hooks';
import { getAppLocale } from './utils/getAppLocale';

export const useIsAppLocaleReady = (): boolean => {
  const user = useAppSelector(selectOptionalUser);
  const { i18n } = useTranslation();
  if (user === undefined) return false;
  return getAppLocale(user.language) === getAppLocale(i18n.language);
};
